import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "../login/loginpage";
import MainLayout from "../layouts/MainLayout";

import Dashboard from "../pages/Dashboard";
import Events from "../pages/Events";
import MemberDirectory from "../pages/MemberDirectory";
import EventParticipants from "../pages/EventParticipants";
// import Vendors from "../pages/Vendors";
import Analytics from "../pages/Analytics";
import Communications from "../pages/Communications";
import Finance from "../pages/Finance";
import WineTracker from "../pages/WineTracker";
import Settings from "../pages/Settings";
// import Approvals from "../pages/Approvals";
import UserList from "../pages/Masters/userlist";
import DocumentMaster from "../pages/Masters/DocumentMaster";
import ApprovalMatrix from "../pages/ApprovalMatrix";
import MemberLogin from "../memberlogin/MemberLogin";
import MemberDetail from "../memberlogin/MemberDetail";
import Memberregistration from "../Registration/MemberRegistration";
// import EventLogin from "../EventLogin/EventLogin";
// import EventDetails from "../EventLogin/EventDetails";
import EventRegistrationPage from "../EventLogin/EventRegistrationPage";
import Procurement from "../pages/Procurement/components/procurement";

import ProcurementDashboard from "../pages/Procurement/views/Dashboard";
import PurchaseOrders from "../pages/Procurement/views/PurchaseOrders";
// import NewPurchaseOrder from "../pages/Procurement/views/NewPurchaseOrder";
import Receipts from "../pages/Procurement/views/Receipts";
import Invoices from "../pages/Procurement/views/Invoices";
import Payments from "../pages/Procurement/views/Payments";
import GradeMaster from "../pages/Masters/GradeMaster";
import RankMaster from "../pages/Masters/RankMaster";
import PriceCategoryMaster from "../pages/Masters/PriceCategoryMaster";
import RateMaster from "../pages/Masters/RateMaster";
import ItemCategoryMaster from "../pages/Masters/ItemCategoryMaster";
import TaxCodeMaster from "../pages/Masters/TaxCodeMaster";
import VendorMaster from "../pages/Masters/VendorMaster";
import UnitMaster from "../pages/Masters/UnitMaster";
import GuestMaster from "../pages/Masters/GuestMaster";
import VNPayCallback from "../EventLogin/VNPayCallback";
function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/MemberLogin" element={<MemberLogin />} />
        <Route path="/MemberLogin/MemberDetail" element={<MemberDetail />} />

        <Route path="/MemberRegistration" element={<Memberregistration />} />
        {/* <Route path="/EventLogin" element={<EventLogin />} />
        <Route path="/EventDetails" element={<EventDetails />} /> */}
        <Route
          path="/EventRegistration/:eventId"
          element={<EventRegistrationPage />}
        />
        <Route path="/vnpay-callback" element={<VNPayCallback />} />
        {/* All pages with Sidebar */}
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/events" element={<Events />} />
          <Route path="/MemberDirectory" element={<MemberDirectory />} />
          <Route path="/EventParticipants" element={<EventParticipants />} />
          {/* <Route path="/vendors" element={<Vendors />} /> */}
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/communications" element={<Communications />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/wine-tracker" element={<WineTracker />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/GradeMaster" element={<GradeMaster />} />
          <Route path="/RankMaster" element={<RankMaster />} />
          <Route path="/RateMaster" element={<RateMaster />} />
          <Route path="/ItemCategoryMaster" element={<ItemCategoryMaster />} />
          <Route path="/TaxCodeMaster" element={<TaxCodeMaster />} />
          <Route path="/VendorMaster" element={<VendorMaster />} />
          <Route path="/UnitMaster" element={<UnitMaster />} />
          <Route path="/GuestMaster" element={<GuestMaster />} />
          <Route
            path="/PriceCategoryMaster"
            element={<PriceCategoryMaster />}
          />
          {/* <Route path="/approvals" element={<Approvals />} /> */}
          <Route path="/userlist" element={<UserList />} />
          <Route path="/DocumentMaster" element={<DocumentMaster />} />
          <Route path="/ApprovalMatrix" element={<ApprovalMatrix />} />
          <Route path="/procurement" element={<Procurement />}>
            <Route index element={<ProcurementDashboard />} />

            <Route path="purchase-orders" element={<PurchaseOrders />} />

            {/* <Route path="purchase-orders/new" element={<NewPurchaseOrder />} /> */}
            <Route path="receipts" element={<Receipts />} />

            <Route path="invoices" element={<Invoices />} />

            <Route path="payments" element={<Payments />} />
          </Route>{" "}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
